module.exports = __webpack_public_path__ + "img/colorful.8a68376f.gif";